import React, { useEffect, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import LandingLayout from "../../../layout/LandingLayout";
import { theme } from "../../../theme/theme";
import MediaViewerModal from "../../../components/Common/MediaViewerModal";
import { getAllPhotos } from "../../../redux/dispatchers/gallery.dispatcher";

const LandingGallery = () => {
  const dispatch = useDispatch();
  const { allPhotos } = useSelector((state) => state.gallery);
  const [selectedPhoto, setSelectedPhoto] = useState(null);

  useEffect(() => {
    dispatch(getAllPhotos());
  }, [dispatch]);

  return (
    <LandingLayout>
      <Typography
        sx={{
          color: "#fff",
          fontFamily: "Mulish-Bold",
          fontSize: "24px",
          mb: 3,
        }}
      >
        Gallery
      </Typography>
      <Grid container spacing={2}>
        {allPhotos?.map((photo) => (
          <Grid item size={{ xs: 6, sm: 4, md: 3 }} key={photo.id}>
            <Box
              component="img"
              src={photo.image_url}
              alt="gallery"
              onClick={() => setSelectedPhoto(photo)}
              sx={{
                width: "100%",
                height: "180px",
                objectFit: "cover",
                borderRadius: "12px",
                border: theme.lightBorder,
                display: "block",
                cursor: "pointer",
              }}
            />
          </Grid>
        ))}
      </Grid>

      <MediaViewerModal
        open={Boolean(selectedPhoto)}
        onClose={() => setSelectedPhoto(null)}
        src={selectedPhoto?.image_url}
        title="Photo"
        rotatable
      />
    </LandingLayout>
  );
};

export default LandingGallery;
